// Rotas de perfil e busca
import { lazy } from "react";
import { ModuleRoutes } from "../types";

const ProfilePage = lazy(() => import("@/pages/profile/ProfilePage"));
const SearchResultsPage = lazy(() => import("@/pages/search/SearchResultsPage"));

export const profileRoutes: ModuleRoutes = {
  moduleId: "profile",
  basePath: "/perfil",
  routes: [
    {
      path: "/perfil",
      element: <ProfilePage />,
    },
    {
      path: "/busca/resultados",
      element: <SearchResultsPage />,
    },
  ],
};
